import { Dispatch, SetStateAction, useMemo } from 'react';
import { GetPatientsBalanceResponse_PatientBalance } from '@weave/schema-gen-ts/dist/schemas/payments/messages/commands/commands.pb';
import { PaginatedList } from '@frontend/components';
import { Row } from '../../../common/mobile-list/row';

type MobileListProps = {
  patients: GetPatientsBalanceResponse_PatientBalance[];
  selected: Record<string, boolean>;
  onSelectionChange: Dispatch<SetStateAction<Record<string, boolean>>>;
};
export const MobileList = ({ patients, selected, onSelectionChange }: MobileListProps) => {
  const selectedArr = useMemo(() => {
    return Object.entries(selected)
      .filter(([_, value]) => value)
      .map(([key, _]) => key);
  }, [selected]);

  const handleClick = (data: GetPatientsBalanceResponse_PatientBalance) => {
    onSelectionChange((prev) => {
      const newSelected = { ...prev };
      if (prev[data.patientId]) {
        delete newSelected[data.patientId];
      } else {
        newSelected[data.patientId] = true;
      }
      return newSelected;
    });
  };

  return (
    <PaginatedList
      height='100%'
      listData={patients}
      renderListItem={({ index, listItem }) => (
        <Row index={index} selected={selectedArr} data={listItem} onClick={handleClick} />
      )}
      hasNextPage={false}
      endOfListText=''
    />
  );
};
